import React from 'react'
import { Proposition } from '@core/Areas/RaceCardFixedOnly/Data/types'
import { getSingleSilkImageUri } from '@core/Areas/RaceCardFixedOnly/Hooks/Silks/api'
import { RaceStatus } from '@core/Areas/RaceCardFixedOnly/constants'
import type { RaceCodesLowerCase } from '@core/Areas/Racing/Types/MeetingInformation'
import type { PreviewTipsTrackerEvent } from '../RaceContent/helpers/analytics'
import { previewTipsTracker } from '../RaceContent/helpers/analytics'
import { TipButton } from './TipButton'

type Props = {
  proposition: Proposition
  buttonPosition: number
  isRaceOpen: boolean
  onClick?: (proposition: Proposition) => void
  isFieldSummaryPopulated?: boolean
  meetingCode?: RaceCodesLowerCase
  racecourseSeq?: number
  meetingDate?: string
  raceNumber?: number
  raceStatus?: PreviewTipsTrackerEvent['raceStatus']
  meetingName?: string
}

export const BettableTipFixedOnly = ({
  proposition,
  buttonPosition,
  isRaceOpen,
  onClick,
  isFieldSummaryPopulated = true,
  meetingCode,
  racecourseSeq,
  meetingDate,
  raceNumber,
  raceStatus,
  meetingName,
}: Props): JSX.Element => {
  const isScratched = proposition.racingStatus === RaceStatus.Scratched
  const isSuspended = proposition.racingStatus === RaceStatus.Suspended

  const price = proposition.winReturn != null ? proposition.winReturn.toFixed(2) : ''

  const imageSize = { width: 32, height: 32, y: 0 }

  const starterNumber = proposition.starterNumber ?? buttonPosition

  const handleClick = () => {
    previewTipsTracker({
      interaction_type: 'Bet Clicked',
      author: 'Racing & Sports',
      raceCode: meetingCode,
      raceStatus,
      meetingName,
    })
    onClick?.(proposition)
  }

  const singleSilkImageUri = getSingleSilkImageUri({
    racecourseSeq,
    meetingDate: meetingDate ?? '',
    raceNumber: raceNumber ?? null,
    isTrots: meetingCode === 'trots',
    isDogs: meetingCode === 'dogs',
    meetingCode: meetingCode,
    starterNumber,
    isFieldSummaryPopulated,
  })
  const imageUrl = singleSilkImageUri

  return (
    <TipButton
      isFixedOddsOnly
      number={starterNumber}
      price={price}
      isScratched={isScratched}
      isSuspended={isSuspended}
      meetingCode={meetingCode}
      imageUrl={imageUrl?.largest.url ?? ''}
      imageSize={imageSize}
      isRaceOpen={isRaceOpen}
      onClick={handleClick}
      toteScratchType=''
    />
  )
}
